import { useState } from "react";

function InputBox({ onChange }) {

    const [text, setText] = useState("")
    const inputHandler = (e) => {
        setText(e.target.value)
        onChange(e.target.value)
    }

    return (
        <div className="w-4/6 flex flex-row-reverse items-center mb-7">
            <img
                src="/image/icon/user.png"
                className="w-7"
            />
            <input
                value={text}
                onChange={inputHandler}
                placeholder="نام کاربری"
                className="text-right pr-4 text-xs w-full bg-purpleLight borderBlue mr-4 rounded py-3 focus:outline-none"
            />
        </div>
    )
}
export default InputBox;